export enum BusinessType {
  B2B = 1,
  B2C = 2,
  B2BOrB2C = 3,
  Digital = 4,
  NonDigital = 5,
  DigitalOrNonDigital = 6,
}
